import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import { getNumberOfReviewers } from "../../ipermissions-context/ipermissions-context.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const reviewerPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // console.log("checkReviewerPolicy -->");
  if (getNumberOfReviewers(context) > 0) {
    // console.log("checkReviewerPolicy --> TRUE");
    // No access needed
  }

  if (next) {
    return next(context, permissions);
  }
};
